/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    h1: {
        fontSize: '29px',
        fontFamily: 'heading',
        fontWeight: 400,
        lineHeight: 'normal',
        letterSpacing: '0.145px'
    },
    h5: {
        fontSize: {base: '20px', md: '23.9px'},
        fontFamily: 'heading',
        fontWeight: 400,
        lineHeight: 'normal',
        letterSpacing: {base: '0.1px', md: '0.12px'}
    },
    h8: {
        fontFamily: 'heading',
        fontSize: '15px',
        lineHeight: 'normal',
        letterSpacing: '0.075px'
    },
    h1Alt: {
        fontFamily: 'caslon',
        lineHeight: 'normal',
        fontSize: {base: '26px', md: '36px', lg: '48px'},
        fontWeight: {base: 400, md: 500, lg: 400},
        letterSpacing: {base: '0.13px', md: '0.18px', lg: '0.24px'}
    },
    p: {
        fontSize: '16px',
        fontWeight: 300,
        lineHeight: '25px'
    },
    large: {
        fontSize: '17px',
        fontWeight: 300,
        lineHeight: '26px',
        letterSpacing: '0.085px'
    },
    small: {
        fontSize: '14px',
        fontWeight: 300,
        lineHeight: '22px',
        letterSpacing: '0.07px'
    }
}
